import React from 'react';
import { motion } from 'framer-motion';
import { type Role } from '../data/surveyData';
interface RoleToggleProps {
  currentRole: Role;
  onRoleChange: (role: Role) => void;
  compact?: boolean;
}
const roles: {
  key: Role;
  label: string;
}[] = [{
  key: 'Nephrologist',
  label: 'Nephrologists'
}, {
  key: 'GP',
  label: 'GPs'
}, {
  key: 'Nurse',
  label: 'Nurses'
}];
export function RoleToggle({
  currentRole,
  onRoleChange,
  compact = false
}: RoleToggleProps) {
  if (compact) {
    return <div className="flex flex-col items-center gap-2" data-id="element-144">
        <span className="text-[11px] font-semibold text-clinical-muted uppercase tracking-wider" data-id="element-145">
          Compare roles
        </span>
        <div className="relative flex bg-gray-100 rounded-full p-0.5" data-id="element-146">
          {roles.map(role => <button key={role.key} onClick={() => onRoleChange(role.key)} className={`relative z-10 px-3 py-1 text-xs font-semibold rounded-full transition-colors duration-200 ${currentRole === role.key ? 'text-white' : 'text-clinical-secondary active:text-clinical-text'}`} data-id="element-147">
              {currentRole === role.key && <motion.div layoutId="compactToggleBg" className="absolute inset-0 bg-era-red rounded-full" transition={{
            type: 'spring',
            stiffness: 400,
            damping: 30
          }} data-id="element-148" />}
              <span className="relative z-10" data-id="element-149">{role.label}</span>
            </button>)}
        </div>
      </div>;
  }
  return <div className="w-full bg-white/90 backdrop-blur-sm border-b border-clinical-border px-4 py-2.5" data-id="element-150">
      <div className="flex items-center justify-between gap-3" data-id="element-151">
        <div className="flex items-center gap-3" data-id="element-152">
          <img src="https://cdn.magicpatterns.com/uploads/ij2eNBe1HzJZKgaPMQ9K3H/Screenshot_2026-03-31_at_15.45.48.png" alt="ERA" className="h-6 object-contain" data-id="element-153" />
          <div className="w-px h-5 bg-gray-200" data-id="element-154" />
          <img src="https://cdn.magicpatterns.com/uploads/ezbVhRkDuKPWYLVJz9KwsF/Screenshot_2026-03-31_at_16.01.46.png" alt="CSL" className="h-5 object-contain" data-id="element-155" />
        </div>
        <div className="relative flex bg-gray-100 rounded-full p-0.5" data-id="element-156">
          {roles.map(role => <button key={role.key} onClick={() => onRoleChange(role.key)} className={`relative z-10 px-3 py-1.5 text-xs font-semibold rounded-full transition-colors duration-200 ${currentRole === role.key ? 'text-white' : 'text-clinical-secondary active:text-clinical-text'}`} data-id="element-157">
              {currentRole === role.key && <motion.div layoutId="roleToggleBg" className="absolute inset-0 bg-era-red rounded-full" transition={{
            type: 'spring',
            stiffness: 400,
            damping: 30
          }} data-id="element-158" />}
              <span className="relative z-10" data-id="element-159">{role.label}</span>
            </button>)}
        </div>
      </div>
    </div>;
}